import { AIPosture } from '@/gen/inventory/v1/ai_posture_pb'

import { aiPostureLabel } from '@/const/label'

import { Badge, BadgeProps } from '@/components/lemmala-design-system/badge/badge'

import { aiPostureBadgeVariantByDisplay } from './variants'

export type AIPostureBadgeProps = {
  posture?: AIPosture
  size?: BadgeProps['size']
  displayVariant?: keyof typeof aiPostureBadgeVariantByDisplay
}

export const AIPostureBadge = ({
  posture,
  size = 'default',
  displayVariant = 'badge',
}: AIPostureBadgeProps) => {
  const resolvedPosture = posture ?? AIPosture.AI_POSTURE_UNSPECIFIED
  const label = aiPostureLabel[resolvedPosture]
  const {
    variant,
    badgeStyle,
    className: variantClassName,
  } = aiPostureBadgeVariantByDisplay[displayVariant][resolvedPosture]

  return (
    <Badge
      variant={variant}
      badgeStyle={badgeStyle}
      size={size}
      textCase='title'
      className={variantClassName}
      data-testid='ai-posture-badge'
    >
      {label}
    </Badge>
  )
}
